



























import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {CancelBedSchedu,CancelDly} from '../../../api/dialysisProcess'
import {GetDicsByCode} from '../../../api/systemBasic'



@Component({
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
   
    mounted() {
        console.log(this.data)
        this.getDicsByCode()
    }
    codeList:any = []
    codeIndex = 0
    async getDicsByCode(){
        let res = await GetDicsByCode({code:'cancel_dialysis_reason'})
        this.codeList = res.objects;
        console.log(res)
    }
    model:any = {
        dialysisSignId:this.data.dialysisSignId,
        type:this.data.canceltype,
        csReason:'',
        describe:''
    }
    //取消本次透析活动
    async cancelDly(){
        this.model.csReason = this.codeList[this.codeIndex].itemCode
        let res = await CancelDly(this.model)
        if(res.status == 1){
            this.$emit('input',false);
            this.$emit('on-success')
        }
        
    }
    
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/cancelDly.vue